export const STORAGE_KEYS = {
  tempUser: "TEMP_USER",
  fcmToken: "FCM_TOKEN",
  PERSIST: "persist:root",
  token: "TOKEN",
  credentials: "CREDENTIALS",
  tokenNode: "TOKEN_NODE",
  rememberedCredentials: "REMEMBERED_CREDENTIALS",
  referralCode: "REFERRAL_CODE",
};
